import axios from "axios";
import { IAPI } from "./IAPI";

export function createAxiosAPI({
  baseUrl,
}: IAPI) {
  const AxiosAPI = axios.create({
    baseURL: baseUrl,
    withCredentials: true,        // mejor aquí
    headers: {
      Accept: "application/json",
      "X-Client-ID": "sales-support",
    },
  });

  AxiosAPI.interceptors.response.use(
    r => r,
    (error) => {
      const status = error?.response?.status;
      if (status === 401 && !window.location.pathname.includes('/login')) {
		window.location.href = "/login";
	  }
    }
  );

  return AxiosAPI;
}

export default createAxiosAPI;
